import {
  Button,
  Center,
  Flex,
  Box,
  Stack,
  Container,
  ScaleFade,
  ListItem,
  Text,
} from "@chakra-ui/react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useState, useEffect } from "react";
import { useUser } from "../lib/accountContext";
import ReactMarkdown from "react-markdown";
import ChakraUIRenderer from "chakra-ui-markdown-renderer";
import toast, { Toaster } from 'react-hot-toast';


const Question = (props) => {
  const { question, tag } = props;
  const user = useUser();

  const [itemText, setItemText] = useState(question.replace("Q: ", ""));

  const newTheme = {
    p: (props) => {
      const { children } = props;
      return (
        <Text mb={2} fontSize={"1.25rem"}>
          {children}
        </Text>
      );
    },
    li: (props) => {
      const { children } = props;
      return (
        <ListItem mb={2} fontSize={"1.25rem"}>
          {children}
        </ListItem>
      );
    },
  };

  const buttons = [
    // {
    //   text: "Copy",
    //   icon: <CopyIcon />,
    //   func: () => { },
    // },
    // {
    //   text: itemSaved ? "Saved" : "Save",
    //   icon: <Icon boxSize={4} as={AiOutlineHeart} />,
    //   func: async () => {
    //     await addDoc(
    //       collection(getFirestore(), `users/${user.uid}/savedItems`),
    //       {
    //         question: itemText,
    //       }
    //     );
    //     setItemSaved(true);
    //   },
    // },
    // {
    //     text: "More Like This",
    //     icon: <Icon boxSize={4} as={AiOutlinePlus} />,
    //     func: () => { },
    // },
    // {
    //     text: "Remove",
    //     icon: <CloseIcon />,
    //     func: () => { },
    // },
  ];

  const onCopy = () => {
    toast.success("Copied!");
  };

  useEffect(() => {
    setItemText(question.replace("Q: ", ""));
  }, [question]);

  return (
    <Container maxWidth="75rem">
      <ScaleFade initialScale={0.75} in={true}>
        <Stack>
          <ReactMarkdown
            components={ChakraUIRenderer(newTheme)}
            children={itemText}
            skipHtml
          />
          ;
          <Box>
            <Flex flexWrap="wrap">
              {buttons.map((button, index) => (
                <Center key={index}>
                  <Box key={index} marginX="3" mt="1.5rem">
                    {button.text === "Copy" ? (
                      <CopyToClipboard onCopy={onCopy} text={itemText}>
                        <Button
                          onClick={button.func}
                          size="md"
                          fontSize="12px"
                          variant="outline"
                          key={index}
                          leftIcon={button.icon}
                        >
                          {button.text}
                        </Button>
                      </CopyToClipboard>
                    ) : (
                      <Button
                        onClick={button.func}
                        size="md"
                        fontSize="12px"
                        variant="outline"
                        key={index}
                        leftIcon={button.icon}
                      >
                        {button.text}
                      </Button>
                    )}
                  </Box>
                </Center>
              ))}
              {tag && (
                <Button
                  mt="1.5rem"
                  size="md"
                  backgroundColor={tag.color}
                  fontSize="12px"
                  variant="outline"
                  key={10}
                >
                  {tag.text}
                </Button>
              )}
            </Flex>
          </Box>
        </Stack>
      </ScaleFade>
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </Container>
  );
};

export default Question;
